// src/frontend/hooks/usePagination.ts
import { useEffect, useState, useCallback } from "react";
import { Message } from "@/frontend/components/common";
import type { ApiResponse } from '@/shared/dto/common';
import { useNavigate } from "react-router-dom";

interface UseGetIdOptions<T> {
    fetchFn: (id?: string) => Promise<ApiResponse<T>>;
    errorMessage?: string;
    id?: string;
    redirectUrl?: string;
}

export function useGetId<T>({
    fetchFn,
    id,
    redirectUrl = "/",
    errorMessage = "Error al cargar datos",
}: UseGetIdOptions<T>) {
    const navigate = useNavigate();
    const [data, setData] = useState<T | null>(null);
    const [loading, setLoading] = useState(true);



    const fetchElementById = useCallback(async (id: string) => {
        try {
            setLoading(true);
            if (!id) {
                Message.error({ content: "ID de usuario no proporcionado" });
                navigate(redirectUrl);
                return;
            }
            const response: ApiResponse<T> = await fetchFn(id);


            if (response.success && response.data) {
                setData(response.data);
            } else {
                Message.error({
                    content: response.error || errorMessage,
                });
                navigate(redirectUrl);
            }
        } catch (err) {
            const errorMessage =
                err instanceof Error ? err.message : "Error al cargar el usuario";
            Message.error({ content: errorMessage });
            navigate("/users");
        } finally {
            setLoading(false);
        }
    }, [fetchFn, id, navigate, redirectUrl, errorMessage]);


    useEffect(() => {
        if (id) {
            fetchElementById(id);
        }
    }, [fetchElementById]);

    return {
        data,
        loading,
    };
}